import Device from './DeviceController';

export default Device;